
export const itemReducer = (state = [], action) => {
    switch(action.type)
    {
        case 'ADD_ITEM':
            return Object.assign([], state,state.concat(action.item.newItem));
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/itemReducer.js